import type { GuideSection } from '../types.js';

import overview from './overview.txt';
import nodeTypes from './node-types.txt';
import specGrammar from './spec-grammar.txt';
import actionNodes from './action-nodes.txt';
import playbook from './playbook.txt';
import bestPractices from './best-practices.txt';
import macros from './macros.txt';
import seedWorkflows from './seed-workflows.txt';
import dataLifecycle from './data-lifecycle.txt';
import assertions from './assertions.txt';
import apiSequences from './api-sequences.txt';
import cliSeeds from './cli-seeds.txt';
import cliApiSequences from './cli-api-sequences.txt';

export const WORKFLOW_GUIDE_CONCEPT_SECTIONS: GuideSection[] = [
  { title: 'Workflow Overview', slug: 'overview', content: overview },
  { title: 'Node Types', slug: 'node-types', content: nodeTypes },
  { title: 'Spec file grammar (.canary.md)', slug: 'spec-grammar', content: specGrammar },
  { title: 'Action Nodes', slug: 'action-nodes', content: actionNodes },
  { title: 'Playbooks & Cache', slug: 'playbook', content: playbook },
  { title: 'Best Practices', slug: 'best-practices', content: bestPractices },
  { title: 'Macros & Variables', slug: 'macros', content: macros },
  { title: 'Seed Workflows', slug: 'seed-workflows', content: seedWorkflows },
  { title: 'Test Data Lifecycle', slug: 'data-lifecycle', content: dataLifecycle },
  { title: 'Assertions', slug: 'assertions', content: assertions },
  { title: 'API Sequences', slug: 'api-sequences', content: apiSequences },
];

export const WORKFLOW_GUIDE_CLI_SECTIONS: GuideSection[] = [
  { title: 'CLI: Seed Workflows', slug: 'cli-seeds', content: cliSeeds },
  { title: 'CLI: API Sequences', slug: 'cli-api-sequences', content: cliApiSequences },
];

export const WORKFLOW_GUIDE_SECTIONS: GuideSection[] = [
  ...WORKFLOW_GUIDE_CONCEPT_SECTIONS,
  ...WORKFLOW_GUIDE_CLI_SECTIONS,
];
